// extracted by mini-css-extract-plugin
module.exports = {"header-basket":"Header_header-basket_3AYOM","headerTop-basket":"Header_headerTop-basket_1LQNf"};